import React, { createContext, useContext, useMemo } from "react";

const AdminModerationContext = createContext(null);

/**
 * Provide platform-admin moderation handlers to feed post/comment UI.
 * @param {Object} props
 * @param {function} props.onRequestDelete
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */
export function AdminModerationProvider({ onRequestDelete, children }) {
  const value = useMemo(() => ({ onRequestDelete }), [onRequestDelete]);
  return (
    <AdminModerationContext.Provider value={value}>
      {children}
    </AdminModerationContext.Provider>
  );
}

/**
 * @returns {{onRequestDelete: Function}|null}
 */
export function useAdminModeration() {
  return useContext(AdminModerationContext);
}
